import * as React from 'react';
import './Alert.scss';

interface IAlertProps {
  type: 'success' | 'error' | 'info';
  className?: string;
  icon: string;
  onClose?: () => void;
  children?: any;
}

export function Alert(props: IAlertProps) {
  const className = `rp-alert ${props.type} ${props.className}`;
  return (
    <div className={className}>
      <span className="rp-alert--icon">
        <i className={props.icon} />
      </span>
      <span className="rp-alert--content">{props.children}</span>
      {props.onClose ? (
        <span className="rp-alert--close">
          <button className="rp-alert--close--button" onClick={props.onClose}>
            <i className="rpds rpds-close" />
          </button>
        </span>
      ) : null}
    </div>
  );
}
